import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React from "react";
import { BoxPlotAggregation } from "#next/components/catalog/base/shared";
import { roundToTwoDecimalPlaces } from "#next/components/preview/interface/RightSideDrawerContent";

export const LanguageTable = ({
  negativeBoxPlot,
  offensiveBoxPlot,
  hatefulBoxPlot,
  violentBoxPlot,
}: {
  negativeBoxPlot: BoxPlotAggregation | null;
  offensiveBoxPlot: BoxPlotAggregation | null;
  hatefulBoxPlot: BoxPlotAggregation | null;
  violentBoxPlot: BoxPlotAggregation | null;
}) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Category</TableCell>
            <TableCell align="center">Average</TableCell>
            <TableCell align="center">Min</TableCell>
            <TableCell align="center">Max</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {negativeBoxPlot && (
            <TableRow
              key="Negative"
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                Negativity
              </TableCell>
              <TableCell component="th" scope="row">
                {roundToTwoDecimalPlaces(negativeBoxPlot.q2)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(negativeBoxPlot.min)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(negativeBoxPlot.max)}
              </TableCell>
            </TableRow>
          )}
          {offensiveBoxPlot && (
            <TableRow
              key="Offensive"
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                Offense
              </TableCell>
              <TableCell component="th" scope="row">
                {roundToTwoDecimalPlaces(offensiveBoxPlot.q2)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(offensiveBoxPlot.min)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(offensiveBoxPlot.max)}
              </TableCell>
            </TableRow>
          )}
          {hatefulBoxPlot && (
            <TableRow
              key="Hateful"
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                Hate
              </TableCell>
              <TableCell component="th" scope="row">
                {roundToTwoDecimalPlaces(hatefulBoxPlot.q2)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(hatefulBoxPlot.min)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(hatefulBoxPlot.max)}
              </TableCell>
            </TableRow>
          )}
          {violentBoxPlot && (
            <TableRow
              key="Violent"
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                Violence
              </TableCell>
              <TableCell component="th" scope="row">
                {roundToTwoDecimalPlaces(violentBoxPlot.q2)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(violentBoxPlot.min)}
              </TableCell>
              <TableCell align="right">
                {roundToTwoDecimalPlaces(violentBoxPlot.max)}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
